import { render } from "./PageVehicle.vue?vue&type=template&id=2748d5f6"
import script from "./PageVehicle.vue?vue&type=script&lang=js"
export * from "./PageVehicle.vue?vue&type=script&lang=js"
script.render = render

export default script